<script setup>
import { useAuthStore } from '../stores';
const authStore = useAuthStore();
</script>
<template>
  <div class="mx-2">
    <p class="text-gray-700 font-semibold mb-4">
      It's never too early to think about kindergarten enrollment. You'll have to collect several documents for you and your child, but we'll be there every step of the way.
    </p>
    <ol class="relative border-l border-gray-200 dark:border-gray-700">
      <li class="mb-10 ml-4">
        <div
          class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700">
        </div>
        <time class="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">6-8 months before</time>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Birth Certificate</h3>
        <p class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">Reach out to your child's hospital for a copy of their birth certificate. This may take some time, so it's best to prepare early.</p>
        <!-- <a href="#"
          class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:outline-none focus:ring-gray-200 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-gray-700">Learn
          more <svg class="w-3 h-3 ml-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 14 10">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M1 5h12m0 0L9 1m4 4L9 9" />
          </svg></a> -->
      </li>
      <li class="mb-10 ml-4">
        <div
          class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700">
        </div>
        <time class="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">4-6 months before</time>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Your State Identification</h3>
        <p class="text-base font-normal text-gray-500 dark:text-gray-400">You'll need a valid ID from a state or federal organization </p>
      </li>
      <li class="mb-10 ml-4">
        <div
          class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700">
        </div>
        <time class="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">4-6 months before</time>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Vaccination Records</h3>
        <p class="text-base font-normal text-gray-500 dark:text-gray-400">Each state has specific vaccination requirements. The most common ones are DTAP, Hepatitis A/B, Polio, etc.</p>
      </li>
    <li class="ml-4">
      <div
        class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700">
      </div>
      <time class="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">1-2 months before</time>
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Proof of Address</h3>
      <p class="text-base font-normal text-gray-500 dark:text-gray-400">You will need two bills or documents from within the past three if you have to verify your eligibility for the district.</p>
    </li>
  </ol>
</div></template>